<template>
  <footer class="mt-5 py-5 bg-dark text-white">
    &copy; chanqwak@naver.com
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>